import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import Section from '@/playbook-builder/components/section';
import type { CollectDocumentNodeProps } from '@/playbook-builder/playbook-builder.types';
import IdDocsView from '../../identity-document/components/id-docs-view';
import AdditionalDocumentsView from './additional-documents-view';
import getDocumentIdentityConfig from './get-default-request-config';
type PersonProps = {
  node: CollectDocumentNodeProps;
};
const Person = t0 => {
  const $ = _c(15);
  const {
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectDocument"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== node) {
    t2 = getDocumentIdentityConfig(node);
    $[1] = node;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const idDocsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== idDocsData) {
    t4 = <IdDocsView data={idDocsData} />;
    $[5] = idDocsData;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Section title={t3}>{t4}</Section>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== node) {
    t6 = <AdditionalDocumentsView node={node} />;
    $[10] = node;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex flex-col gap-4">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default Person;
function _temp($) {
  return $.title;
}